var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var responsiveTypographyH1 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h1), (_a = { fontSize: typography.pxToRem(30), lineHeight: 1.17, letterSpacing: typography.pxToEm(-0.3, 30) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(40),
        lineHeight: 1.12,
        letterSpacing: typography.pxToEm(-0.5, 40),
    }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(50),
        lineHeight: 1.1,
        letterSpacing: typography.pxToEm(-1, 50),
    }, _a)));
};
var responsiveTypographyH2 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h2), (_a = { fontSize: typography.pxToRem(26), lineHeight: 1.15, letterSpacing: typography.pxToEm(-0.3, 26) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(30),
        lineHeight: 1.17,
        letterSpacing: typography.pxToEm(-0.5, 30),
    }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(36),
        lineHeight: 1.11,
        letterSpacing: typography.pxToEm(-0.7, 36),
    }, _a)));
};
var responsiveTypographyH3 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h3), (_a = { fontSize: typography.pxToRem(20), lineHeight: 1.25, letterSpacing: typography.pxToEm(-0.2, 20) }, _a[breakpoints.up("xl")] = {
        fontSize: typography.pxToRem(22),
        lineHeight: 1.59,
        letterSpacing: typography.pxToEm(-0.5, 22),
    }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(36),
        lineHeight: 1.11,
        letterSpacing: typography.pxToEm(-0.7, 36),
    }, _a)));
};
var responsiveTypographyH4 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h4), (_a = { fontSize: typography.pxToRem(18), lineHeight: 1.39, letterSpacing: typography.pxToEm(-0.2, 18) }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(22),
        lineHeight: 1.36,
        letterSpacing: typography.pxToEm(-0.4, 22),
    }, _a)));
};
var responsiveTypographyH5 = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.h5), (_a = { fontSize: typography.pxToRem(18), lineHeight: 1.39, letterSpacing: typography.pxToEm(-0.2, 18) }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(22),
        lineHeight: 1.36,
        letterSpacing: typography.pxToEm(-0.4, 22),
    }, _a)));
};
var responsiveTypographyBody = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.body1), (_a = { fontSize: typography.pxToRem(14), lineHeight: 1.43, letterSpacing: typography.pxToEm(0.2, 14) }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(16),
        lineHeight: 1.25,
        letterSpacing: "normal",
    }, _a)));
};
var responsiveTypographyCaption = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.caption), (_a = { fontSize: typography.pxToRem(12), lineHeight: 1.25, letterSpacing: "normal" }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(14),
        lineHeight: 1.43,
    }, _a)));
};
var responsiveTypographyButton = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.button), (_a = { fontSize: typography.pxToRem(12), lineHeight: 1.25, letterSpacing: typography.pxToEm(0.5, 12) }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(14),
        lineHeight: 1.07,
        letterSpacing: typography.pxToEm(1, 14),
    }, _a)));
};
var responsiveTypographyOverline = function (typography, breakpoints) {
    var _a;
    return (__assign(__assign({}, typography.overline), (_a = { fontSize: typography.pxToRem(9), lineHeight: 1.67, letterSpacing: typography.pxToEm(1, 9) }, _a[breakpoints.up("xxl")] = {
        fontSize: typography.pxToRem(11),
        lineHeight: 1.36,
        letterSpacing: typography.pxToEm(0.5, 11),
    }, _a)));
};
export var responsiveTypography = function (theme) {
    var typography = theme.typography, breakpoints = theme.breakpoints;
    var h1 = responsiveTypographyH1(typography, breakpoints);
    var h2 = responsiveTypographyH2(typography, breakpoints);
    var h3 = responsiveTypographyH3(typography, breakpoints);
    var h4 = responsiveTypographyH4(typography, breakpoints);
    var h5 = responsiveTypographyH5(typography, breakpoints);
    var body = responsiveTypographyBody(typography, breakpoints);
    var caption = responsiveTypographyCaption(typography, breakpoints);
    var button = responsiveTypographyButton(typography, breakpoints);
    var overline = responsiveTypographyOverline(typography, breakpoints);
    return __assign(__assign({}, theme), { typography: __assign(__assign({}, theme.typography), { h1: h1, h2: h2, h3: h3, h4: h4, h5: h5, body1: body, body2: body, caption: caption, button: button, overline: overline }) });
};
//# sourceMappingURL=responsiveTypography.js.map